// ANGULAR
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { MetaReducer, StoreModule } from '@ngrx/store';

// CUSTOM MODULES
import { GlobalStoreModule } from './global/global-store.module';
import { MasterStoreModule } from './master/master-store.module';
import { AuthStoreModule } from './modules/auth/auth-store.module';
import { BusinessStoreModule } from './modules/business/business-store.module';
import { DashboardStoreModule } from './modules/dashboard/dashboard-store.module';
import { MasterBusinessStoreModule } from './modules/master-business/master-business-store.module';
import { PermissionStoreModule } from './modules/permission/permission-store.module';
import { UserStoreModule } from './modules/user/user-store.module';

// SERVICES
import { ApiConfigService } from './core/services/api-config/api-config.service';
import { TokenStorageService } from './core/services/token-storage/token-storage.service';

// STORE
import { NotificationStoreModule } from './modules/notification/notification-store.module';
import { CustomSerializer } from './router/custom-serializer';

const metaReducers: Array<MetaReducer<any, any>> = [];

/**
 * This module is for configure all ngrx related stuff.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) configure ngrx store in ng module
 */
@NgModule({
  declarations: [],
  imports: [

    /********************NGRX MODULES*******************/
    StoreModule.forRoot({ router: routerReducer }, { metaReducers }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    /********************NGRX MODULES*******************/

    /** IMPORT CUSTOM MODULE HERE. */
    GlobalStoreModule,
    MasterStoreModule,
    AuthStoreModule,
    BusinessStoreModule,
    MasterBusinessStoreModule,
    UserStoreModule,
    DashboardStoreModule,
    PermissionStoreModule,
    NotificationStoreModule,
  ],
  providers: [
    TokenStorageService,
    ApiConfigService,
    { provide: RouterStateSerializer, useClass: CustomSerializer },
  ],
})
export class StateModule { }
